module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wrap"
  }, [_c('div', {
    staticClass: "main"
  }, [_c('img', {
    staticClass: "big-img",
    attrs: {
      "src": require("src/assets/image/permission.png")
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "text"
  }, [_c('img', {
    attrs: {
      "src": require("src/assets/image/permission-logo.png")
    }
  }), _vm._v(" "), _c('div', [_c('div', [_vm._v("很抱歉")]), _vm._v(" "), _c('div', [_vm._v("您没有权限访问，请联系超级管理员"), _c('span', {
    staticClass: "green",
    on: {
      "click": _vm.link
    }
  }, [_vm._v("返回首页")])])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@10.3.0@vue-loader/lib/template-compiler.js?id=data-v-49822e0e!./~/_vue-loader@10.3.0@vue-loader/lib/selector.js?type=template&index=0!./src/components/page-noPermission.vue
// module id = 739
// module chunks = 1